import Icon from '@components/dataDisplay/Icons/Icon';
import React from 'react';
import styled, { css } from 'styled-components';

const sizeMap = {
  md: css`
    padding: 12px;
  `,
  sm: css`
    padding: 6px;
  `,
};

const fixedStyle = css`
  position: absolute;
  top: 16px;
  left: 16px;
`;

const shapeMap = {
  default: css``,
  stroke: css`
    border: 1px solid var(--cardLineColor);
    background-color: var(--cardBackgroundColor);
  `,
};

const CloseBtnWrap = styled.button<{
  size?: 'sm' | 'md';
  shape?: 'default' | 'stroke';
  fixed?: boolean;
}>`
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ size }) => size && sizeMap[size]};
  ${({ shape }) => shape && shapeMap[shape]};
  ${({ fixed }) => fixed && fixedStyle};
  z-index: 1;
  &:hover {
    background-color: var(--inkColor);
  }

  @media (max-width: 480px) {
    touch-action: manipulation;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: transparent;
  }
`;

interface Props {
  onClick?: any;
  color?: string;
  size?: 'sm' | 'md';
  shape?: 'default' | 'stroke';
  style?: React.CSSProperties;
  fixed?: boolean;
}

function CloseBtn({
  onClick,
  color,
  size = 'md',
  shape = 'default',
  style,
  fixed,
}: Props) {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <CloseBtnWrap
      fixed={fixed}
      onClick={handleClick}
      size={size}
      shape={shape}
      style={style}
    >
      <Icon
        name={size === 'sm' ? 'X12' : 'X14'}
        color={color || 'var(--textColor)'}
      />
    </CloseBtnWrap>
  );
}

export default CloseBtn;
